module.exports = "/images/privacy_policy_hero.svg?4a983c435a28c98d13e01852a1bdd20b";